import { PageLocatorMap } from '../types/PageLocatorMap';

export const applySearchYearPage = {
  footer: {
    root: 'apply-search-year-page.footer.root',
  },
  form: {
    accessibilitySubmit: 'apply-search-year-page.form.accessibility-submit',
    getRadioOption: (index: number): string =>
      `apply-search-year-page.form.radio-option-${index + 1}`,
    h1: 'apply-search-year-page.form.h1',
    h2: 'apply-search-year-page.form.h2',
    radioGroupRoot: 'apply-search-year-page.form.radio-group-root',
    root: 'apply-search-year-page.form.root',
  },
  header: {
    drawerButton: 'apply-search-year-page.header.drawer-button',
    previousStepButton: 'apply-search-year-page.header.previous-step-button',
    root: 'apply-search-year-page.header.root',
  },
  progress: {
    root: 'apply-search-year-page.progress.root',
  },
} as const satisfies PageLocatorMap;
